import { render, staticRenderFns } from "./LiveMatches.vue?vue&type=template&id=bdd37198&scoped=true&"
import script from "./LiveMatches.vue?vue&type=script&lang=js&"
export * from "./LiveMatches.vue?vue&type=script&lang=js&"
import style0 from "./LiveMatches.vue?vue&type=style&index=0&id=bdd37198&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd37198",
  null
  
)

export default component.exports